import { useState } from 'react';

import Switch from '~/components/Forms/Switch';

import type { SubscriberPreference } from '~/interfaces/subscriber_preferences';

import PreferenceDescription from './PreferenceDescription';
import PreferenceName from './PreferenceName';

interface Props {
  onChange: (value: boolean) => void;
  preference: SubscriberPreference;
}

const BooleanField = ({ preference, onChange }: Props) => {
  const [enabled, setEnabled] = useState(
    Boolean(preference.value && preference.value.toString().toLowerCase() === 'true'),
  );

  const handleChange = (checked: boolean) => {
    const newValue = checked === true;
    setEnabled(newValue);
    onChange(newValue);
  };

  return (
    <div className="flex flex-row items-center gap-x-4 gap-y-2">
      <div className="flex w-80 flex-col gap-y-0.5">
        <PreferenceName name={preference.name} />
        <PreferenceDescription description={preference.description} />
      </div>
      <Switch checked={enabled} onChange={handleChange} />
    </div>
  );
};

export default BooleanField;
